import { ReactNode } from 'preact/compat';

type TrackingOverlayProps = {
    children: ReactNode;
};
export function TrackingOverlay({ children }: TrackingOverlayProps) {
    return (
        <>
            <div className="absolute z-40 w-full h-full bg-[rgba(0,0,0,0.6)] pointer-events-none">
                {children}
            </div>
        </>
    );
}
